module.exports = __webpack_public_path__ + "static/img/Frame.a3c275cd.svg";